export const projectsData = [
    {
        projectName: 'PTrip Travel Website',
        projectDescription:
            'Developed a travel website that can be used to browse adventures and make reservations. Deployed the website using Netlify and Heroku.',
        projectUrl: ' https://ptrip-travel.netlify.app/',
        projectSkills: 'HTML, CSS, Javascript, Bootstrap, JQuery, REST APIs, Deployment',
        projectDuration: 'July 2021 - Aug 2021'
    },
    {
        projectName: 'Flat Booking & Flatmate Searching ',
        projectDescription:
            'Built an android application for flat booking and flatmate searching having login facility, sms notification, map activity, navigation drawer and a strong GUI with splash screen and animation.',
        projectUrl: '',
        projectSkills: 'Android App Development, Java, Android Studio, Firebase',
        projectDuration: 'Aug 2018 - Oct 2018'
    },
    {
        projectName: 'Name It',
        projectDescription:
            'Built a name suggestion application using react which helps to find the cool names for  project, venture, or startup.',
        projectUrl: 'https://PranaliLahoti.github.io/nameit/',
        projectSkills: 'React, CSS, Deployment',
        projectDuration:'Feb 2021'
    },
    {
        projectName: 'Online Course Registration System',
        projectDescription:
            'Developed a desktop application for an online programming course registration system having CRUD functionalities.',
        projectUrl: '',
        projectSkills:'Java, MySQL',
        projectDuration: 'Aug 2018 - Sept 2018'
    },
    {
        projectName: 'Portfolio Website',
        projectDescription:
            'Developed my own portfolio website showcasing my academic qualification, industrial experience, projects, skills, certifications, achievements, contact details.',
        projectUrl: 'https://pranalilahoti.github.io/portfolio/',
        projectSkills:'React, Javascript, Html, CSS',
        projectDuration: 'Aug 2021 - Sept 2021'
    },
    {
        projectName: 'Smart Greenhouse',
        projectDescription:
            'An IEEE sponsored IOT based project. In this project, soil moisture sensor is used to automate irrigation and temperature sensor is used to automate fogger systems. According to the temperature required to the plants, the lighting system is on or off. ',
        projectUrl: '',
        projectSkills:'Internet of Things(IOT)',
        projectDuration: 'Feb 2019 - Oct 2019'
    },
    // {
    //     projectName: 'PokeDex',
    //     projectDescription:
    //         "Pokemon was a huge part of our childhood, wasn't it? Talking about pokemon brings back so many memories, but do you remember the details of each pokemon? Probably No! So here I bring you a pokedex to check all pokemons :)",
    //     projectUrl: 'http://theleanprogrammer.com/pokedex/',
    // },
   
];
